@if (profileField$ | async; as profileField) {
  <sh-form-group
    [id]="profileField.FieldDefinition.FlatKey"
    [label]="profileField.DisplayLabel"
    [labelIcons]="labelIcons"
    [required]="profileField.Required"
    [helpText]="profileField.Description"
    [errorMsg]="(errorMsg$ | async) || '' | translate"
    [title]="disabledMessageKey | translate"
    >
    @if (isBulkEdit$ | async) {
      <p class="sh-form-group__warning sh-preserve-linebreaks">
        {{ "profile-form.complex-input-field.bulk-edit-warning" | translate: { fieldName: profileField.DisplayLabel } }}
      </p>
    }
    @if (isBatchEdit) {
      <p class="sh-form-group__warning sh-preserve-linebreaks">
        {{ "profile-form.complex-input-field.batch-edit-warning" | translate: { fieldName: profileField.DisplayLabel } }}
      </p>
    }
    <!-- Merge Strategy Component-->
    <ng-content></ng-content>
    @for (profileField of childProfileFields$ | async; track profileField) {
      @if (profileField.FieldDefinition) {
        <sh-generic-field
          [style]="nestedPadding$ | async"
          [profileField]="profileField"
          [formGroup]="formGroup"
          [records]="records$ | async"
          [isBatchEdit]="isBatchEdit"
          [canEditStandard]="canEdit$ | async"
          [canEditAdvanced]="canEdit$ | async"
          [nestedIndex]="(nestedIndex$ | async)! + 1"
          [autocompleteFct]="undefined"
          >
        </sh-generic-field>
      } @else {
        <dt class="sh-description-list__term">{{ profileField.DisplayLabel }}</dt>
        <dd class="sh-description-list__details">{{ "form.error.fielddefinition-not-found" | translate: { id: profileField.FieldDefinitionId } }}</dd>
      }
    }
  </sh-form-group>
}
